import { render, staticRenderFns } from "./BezorgLijstCreate.vue?vue&type=template&id=5cc7b61b&scoped=true&"
import script from "./BezorgLijstCreate.vue?vue&type=script&lang=js&"
export * from "./BezorgLijstCreate.vue?vue&type=script&lang=js&"
import style0 from "./BezorgLijstCreate.vue?vue&type=style&index=0&id=5cc7b61b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7b61b",
  null
  
)

export default component.exports